import React from "react";

/**
 * ToothAssistantIcon — Dhembi + simboli i mjekut (cross / wrench)
 * Stilizuar te jete e qarte ne madhesi te vogla (16-40px).
 *
 * Props:
 *   size: number (default 22)
 *   className: string
 *   pulse: boolean — shton nje rrethin e bardhe pulsues qe tregon "online"
 */
export default function ToothAssistantIcon({ size = 22, className = "", pulse = false }) {
  return (
    <span
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 32 32"
        width={size}
        height={size}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Trupi i dhembit */}
        <path
          d="M9.5 4.2c-2.6 0-4.7 2-4.7 4.5 0 1.6.5 2.6 1.2 4.8.5 1.7.8 3.6.9 5.6.1 2.6.4 4.7 1.0 6.4.5 1.5 1.4 2.4 2.6 2.4 1.3 0 1.9-1.1 2.4-3.5l.6-2.7c.3-1.3 1.1-2.1 2.3-2.1 1.2 0 2.0.8 2.3 2.1l.6 2.7c.5 2.4 1.1 3.5 2.4 3.5 1.2 0 2.1-.9 2.6-2.4.6-1.7.9-3.8 1.0-6.4.1-2.0.4-3.9.9-5.6.7-2.2 1.2-3.2 1.2-4.8 0-2.5-2.1-4.5-4.7-4.5-1.5 0-2.5.4-3.3.8-.9.4-1.5.7-2.7.7s-1.8-.3-2.7-.7c-.8-.4-1.8-.8-3.3-.8z"
          fill="currentColor"
        />
        {/* Shenja '+' e mjekut */}
        <g transform="translate(20.5 8.5)">
          <circle r="5" fill="#FFFFFF" stroke="currentColor" strokeWidth="1.4" />
          <rect x="-2.6" y="-0.8" width="5.2" height="1.6" rx="0.4" fill="#D44A4A" />
          <rect x="-0.8" y="-2.6" width="1.6" height="5.2" rx="0.4" fill="#D44A4A" />
        </g>
      </svg>
      {pulse && (
        <span
          className="absolute -bottom-0.5 -right-0.5 inline-block rounded-full bg-emerald-400 ring-2 ring-white animate-pulse"
          style={{ width: Math.max(6, size * 0.28), height: Math.max(6, size * 0.28) }}
        />
      )}
    </span>
  );
}
